import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Camera, Users, TrendingUp, Handshake, Sparkles } from "lucide-react";
import { Section, SectionHeading, Eyebrow, GlassCard, Reveal } from "../components/ui-shared";

const signals = [
  { t: "CONTENT", d: "What you create.", icon: Camera },
  { t: "AUDIENCE", d: "Who engages with your content.", icon: Users },
  { t: "PERFORMANCE", d: "How your content performs.", icon: TrendingUp },
  { t: "COLLABORATION", d: "What type of brand work you take on.", icon: Handshake },
];

export default function Creators() {
  return (
    <div>
      <section className="pt-16 sm:pt-24 pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="max-w-3xl">
            <Eyebrow>For Creators</Eyebrow>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-white">
              YOUR CONTENT.<br />
              <span className="bg-gradient-to-r from-cyan-300 to-purple-300 bg-clip-text text-transparent">DISCOVERED DIFFERENTLY.</span>
            </h1>
            <p className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed max-w-xl">
              Orbit gives businesses a structured way to discover creators based on campaign requirements, content and performance information.
            </p>
            <div className="mt-5">
              <span className="pill"><Sparkles size={13} /> 100% Free for Creators during Private Beta</span>
            </div>
            <Link to="/creator-apply" className="btn-primary mt-8">Apply for Private Beta <ArrowRight size={18} /></Link>
          </motion.div>
        </div>
      </section>

      {/* CREATOR MESSAGE */}
      <Section className="!pb-8">
        <Reveal>
          <GlassCard hover={false} className="p-8 sm:p-12">
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
              CREATORS — YOUR TIME IS NOW.
            </h2>
            <p className="mt-4 max-w-2xl text-base text-slate-300 leading-relaxed">
              Join the Private Beta completely free and put your content in front of businesses looking for relevant creator partnerships.
            </p>
          </GlassCard>
        </Reveal>
      </Section>

      {/* PROFILE SIGNALS */}
      <Section className="!pt-8">
        <Reveal>
          <SectionHeading eyebrow="Profile signals" title="THE SIGNALS THAT HELP YOU GET DISCOVERED." />
        </Reveal>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {signals.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.08}>
              <GlassCard className="p-6 h-full">
                <span className="grid place-items-center h-11 w-11 rounded-xl bg-cyan-500/12 border border-cyan-400/20 text-cyan-300">
                  <s.icon size={19} />
                </span>
                <h3 className="mt-5 font-display text-lg font-semibold text-white">{s.t}</h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.d}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-sm text-slate-400">
            These signals help businesses discover creators relevant to their campaign requirements.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between rounded-2xl glass p-6 sm:p-8">
            <p className="text-base text-slate-300">Ready to be discovered on your terms?</p>
            <Link to="/creator-apply" className="btn-primary">Apply for Private Beta <ArrowRight size={18} /></Link>
          </div>
        </Reveal>
      </Section>
    </div>
  );
}
